export var ExcelEnum;
(function (ExcelEnum) {
    ExcelEnum["BALANCES_PER_ASSET"] = "balances-per-asset";
    ExcelEnum["BALANCES_PER_USER"] = "balances-per-user";
    ExcelEnum["ASSET_BALANCES_PER_USER"] = "asset-balances-per-user";
    ExcelEnum["CASH_TRANSACTIONS"] = "cash-transactions";
    ExcelEnum["COLLECTOR_RULES"] = "collector-rules";
    ExcelEnum["COMPLIANCE"] = "compliance";
    ExcelEnum["CRYPTO_MANUAL_ACTIONS"] = "crypto-manual-actions";
    ExcelEnum["EXCHANGE_BONUSES"] = "exchange-bonuses";
    ExcelEnum["LIQUIDATOR_ACCOUNT_EXCHANGES"] = "liquidator-account-exchanges";
    ExcelEnum["EXTERNAL_PROVIDER_CRYPTO_BALANCES"] = "external-provider-crypto-balances";
    ExcelEnum["ACTIVE_REFERRERS"] = "active-referrers";
    ExcelEnum["USER_REFERRALS"] = "user-referrals";
    ExcelEnum["EXCHANGE_FEES"] = "exchange-fees";
    ExcelEnum["EXCHANGE_RATE_MARGINS"] = "exchange-rate-margins";
    ExcelEnum["EXCHANGES"] = "exchanges";
    ExcelEnum["EXTERNAL_BALANCES"] = "external-balances";
    ExcelEnum["EXTERNAL_WALLETS"] = "external-wallets";
    ExcelEnum["FIAT_MANUAL_ACTIONS"] = "fiat-manual-actions";
    ExcelEnum["GAS_STATION_RULES"] = "gas-station-rules";
    ExcelEnum["KRAKEN_ORDER_HISTORY"] = "kraken-order-history";
    ExcelEnum["REBALANCER_RULE_PAIRS"] = "rebalancer-rule-pairs";
    ExcelEnum["REBALANCER_RULES"] = "rebalancer-rules";
    ExcelEnum["SWAP_TRANSACTIONS"] = "swap-transactions";
    ExcelEnum["TRANSACTIONS"] = "transactions";
    ExcelEnum["USER_BALANCES"] = "user-balances";
    ExcelEnum["USER_DEPOSITS"] = "user-deposits";
    ExcelEnum["USER_FILES"] = "user-files";
    ExcelEnum["USER_SWAP_HISTORY"] = "user-swap-history";
    ExcelEnum["USER_TRANSACTIONS"] = "user-transactions";
    ExcelEnum["USERS"] = "users";
    ExcelEnum["CARD_LOCKED_USERS"] = "card-locked-users";
    ExcelEnum["USER_DOCUMENTS"] = "user-documents";
    ExcelEnum["WITHDRAWAL_FEES"] = "withdrawal-fees";
    ExcelEnum["FIREBLOCKS_BALANCE_BY_ASSET"] = "fireblocks-balance-by-asset";
    ExcelEnum["EXCHANGE_REPORTS"] = "exchange-reports";
    ExcelEnum["REFERRED_EXCHANGE_REPORTS"] = "referred-exchange-reports";
    ExcelEnum["NON_REFERRED_EXCHANGE_REPORTS"] = "non-referred-exchange-reports";
    ExcelEnum["CM_REFERRED_EXCHANGE_REPORTS"] = "cm-referred-exchange-reports";
    ExcelEnum["SETTLEMENT_ORDERS"] = "settlement-orders";
})(ExcelEnum || (ExcelEnum = {}));
//# sourceMappingURL=excel.enum.js.map